import { render, staticRenderFns } from "./SentMailToAcademicas.vue?vue&type=template&id=3fec59d2&"
import script from "./SentMailToAcademicas.vue?vue&type=script&lang=js&"
export * from "./SentMailToAcademicas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports